import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungMainz() {
  return (
    <CityPageTemplate
      city="Mainz"
      slug="mainz"
      intro="In der rheinland-pfälzischen Landeshauptstadt Mainz setzen wir auf digitale, unabhängige Beratung."
      description="Unabhängige & digitale Finanzberatung für Mainz: Altersvorsorge, ETF, Steueroptimierung und staatliche Förderungen. Kostenlose Erstberatung – 100% digital."
    />
  );
}
